/**
 * Klarna Payment Updater
 * Updates the Klarna payment amount when a variant is selected
 */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize the payment updater
  initKlarnaPaymentUpdater();
});

/**
 * Initialize the Klarna payment updater to listen for variant changes
 */
function initKlarnaPaymentUpdater() {
  // Find all Klarna payment containers on the page
  const klarnaContainers = document.querySelectorAll('[data-klarna-payment-container]');
  
  if (klarnaContainers.length === 0) return;
  
  // Listen for variant changes using the variantChange event that Shopify themes typically emit
  document.addEventListener('variant:change', function(event) {
    if (!event.detail.variant) return;
    
    updateKlarnaPayment(event.detail.variant.price);
  });
  
  // Also listen for variant changes via select elements (as a fallback)
  const variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const variantId = this.value;
      const variant = findVariantById(variantId);
      
      if (variant && variant.price) {
        updateKlarnaPayment(variant.price);
      }
    });
  });
  
  // Listen to the URL for changes that might indicate a variant change
  if (window.location.search.includes('variant=')) {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    
    if (variantId) {
      const variant = findVariantById(variantId);
      if (variant && variant.price) {
        updateKlarnaPayment(variant.price);
      }
    }
  }
}

/**
 * Update the Klarna payment amount based on the variant price
 * @param {number} price - The price in cents
 */
function updateKlarnaPayment(price) {
  if (!price) return;
  
  // Convert price from cents to dollars if necessary (Shopify stores prices in cents)
  const priceInDollars = typeof price === 'string' ? parseFloat(price) / 100 : price / 100;
  
  // Calculate 4 equal payments
  const paymentAmount = (priceInDollars / 4).toFixed(2);
  
  // Format the payment amount with currency
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  
  const formattedPayment = formatter.format(paymentAmount);
  
  // Update all Klarna payment amounts on the page
  const paymentElements = document.querySelectorAll('.klarna-amount');
  paymentElements.forEach(element => {
    element.textContent = formattedPayment;
  });
}

/**
 * Find a variant by its ID from the product JSON
 * @param {string} variantId - The variant ID to find
 * @returns {Object|null} - The variant object or null if not found
 */
function findVariantById(variantId) {
  // Check if the product JSON exists on the page (Shopify standard)
  if (typeof meta !== 'undefined' && meta.product && meta.product.variants) {
    return meta.product.variants.find(variant => variant.id.toString() === variantId.toString());
  }
  
  // Fallback if we can't find the variant
  return null;
}
